<template>
  <v-dialog
    v-model="showTryLession"
    content-class="show-try-lession"
    width="800"
    @click:outside="closeDialog"
  >
    <v-card>
      <v-btn
          style="z-index: 9;
          float: right;"
          class="ma-0 text-left"
          icon
          medium
          @click="closeDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      <v-card-title class="pt-0">
        <h3 class="pt-0 text-center">Thông tin buổi học thử</h3>
      </v-card-title>
      <v-tabs>
        <template v-for="item in listChild">
          <v-tab
            :key="item.id"
            @change="changeChild(item.vhUserId)"
            v-if="!item.isMainCustomer"
            >{{ item.fullName }}</v-tab
          >
        </template>
      </v-tabs>
      <v-card-text>
        <v-data-table
          :fixed-header="true"
          :headers="headers"
          :items="listInfoTryLession"
          hide-default-footer
          disable-sort
        >
          <template v-slot:item.section_title="{ item }">
            <a class="name-lession" :href="item.link_report" target="_blank">{{
              item.section_title
            }}</a>
          </template>
          <template v-slot:item.star_of_report="{ item }">
            {{ item.star_of_report }}
            <v-icon style="color:#f88343">
              mdi-star-outline
            </v-icon>
          </template>
          <template v-slot:item.link_report="{ item }">
            <v-icon @click="copyLinkUrl(item.link_report)">
              mdi-content-copy
            </v-icon>
            Copy link
          </template>
        </v-data-table>
        <v-row>
          <v-col cols="12" sm="6" />
          <v-col cols="12" sm="6">
            <div class="pb-3">
              <v-col
                cols="12"
                md="12"
                class="pb-0 pa-0"
                style="display: flex; justify-content: flex-end; padding: 0 12px"
              >
                <div class="text-right mb-1 mt-2 ml-4 sticky-right">
                  {{ showIndex() }}
                  <v-btn
                    small
                    class="pagination-btn-left"
                    @click="
                      () => {
                        currentPage--;
                      }
                    "
                    :disabled="currentPage == 1"
                  >
                    <v-icon>mdi-menu-left</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="currentPage == total_pages || total_pages == 0"
                    small
                    class="pagination-btn-right"
                    @click="
                      () => {
                        currentPage++;
                      }
                    "
                  >
                    <v-icon>mdi-menu-right</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import RepositoryFactory from "../../../repositories/RepositoryFactory";
const ContactRepository = RepositoryFactory.get("contact");

export default {
  name: "ModalInfoTryLession",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    listChild: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentPage: 1,
      per_page: 10,
      listInfoTryLession: [],
      showTryLession: false,
      headers: [
        { text: "Buổi học", value: "section_title", align: "left" },
        {
          text: "Thời gian buổi học",
          value: "section_start_time",
          align: "center",
        },
        { text: "Khối", value: "grade", align: "center" },
        { text: "Sao tổng", value: "star_of_report", align: "center" },
        {
          text: "Link báo cáo",
          value: "link_report",
          align: "center",
          sortable: false,
        },
      ],
      totalItems: 0,
      total_pages: 0,
    };
  },
  methods: {
    changeChild(userId) {
      if (!userId) {
        this.totalItems = 0;
        this.total_pages = 0;
        this.listInfoTryLession = [];
        return;
      }
      this.userId = userId;
      this.currentPage = 1;
      this.getListInfoTryLesson();
    },
    async copyLinkUrl(link) {
      // save link to clip board
      await navigator.clipboard.writeText(link);
      this.$swal({
        title: "Copy link thành công",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    },
    async getListInfoTryLesson() {
      if (!this.userId) {
        return;
      }
      const loading = this.$loading.show();
      let res = await ContactRepository.getListInfoTryLesson(this.userId, {
        page: this.currentPage,
        per_page: this.per_page,
      });
      loading.hide();
      if (_.get(res, "success", false)) {
        this.listInfoTryLession = res.data.items;
        this.totalItems = res.data.pagination.total_item;
        this.total_pages = res.data.pagination.total_pages;
      } else {
        console.error('Có lỗi xảy ra khi thực hiện lấy thông tin báo cáo học thử DUO', res);
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    showIndex() {
      if (this.listInfoTryLession.length > 0) {
        let maxIndex =
          this.listInfoTryLession.length < this.per_page
            ? parseInt(this.currentPage - 1) * parseInt(this.per_page) +
              this.listInfoTryLession.length
            : parseInt(this.currentPage) * parseInt(this.per_page);
        return this.listInfoTryLession.length < this.per_page
          ? maxIndex -
              parseInt(this.listInfoTryLession.length) +
              1 +
              " - " +
              maxIndex
          : maxIndex - parseInt(this.per_page) + 1 + " - " + maxIndex;
      } else {
        return "0 - 0";
      }
    },
  },
  watch: {
    show: {
      handler(val) {
        console.log("val", val);
        this.showTryLession = val;
      },
    },
    currentPage: {
      async handler() {
        await this.getListInfoTryLesson();
      },
    },
    userId: {
      async handler() {
        await this.getListInfoTryLesson();
      },
    },
    listChild: {
      async handler() {
        this.userId = this.listChild.find(
          (item) => !item.isMainCustomer && item.vhUserId
        )?.vhUserId;
        await this.getListInfoTryLesson();
      },
    },
  },
  async created() {
    this.userId = this.listChild.find(
      (item) => !item.isMainCustomer && item.vhUserId
    )?.vhUserId;
    await this.getListInfoTryLesson();
  },
};
</script>

<style lang="scss">
.show-try-lession {
  th {
    font-size: 16px !important;
    font-weight: 700 !important;
  }
  a.name-lession {
    color: #000;
  }
}
</style>
